import { IKnm } from 'APIPackage/KnmModule/interfaces/IKnm';
import { IKnmParams } from 'APIPackage/KnmModule/interfaces/IKnmParams';

export const mergeKnmParams = (oldValues: IKnm, newValues: IKnmParams) => ({
  ...oldValues,
  ...newValues,
  ...(newValues.approve && {
    approve: {
      ...oldValues.approve,
      ...newValues.approve,
    },
  }),
  documents: newValues.documents,
  requirements: newValues.requirements,
});
